<template>
    <div class="min-h-screen bg-white flex">
        <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
            <div class="mx-auto w-full max-w-sm lg:w-96">
                <div class="flex items-center justify-center">
                    <img
                        class="h-12 w-auto"
                        :src="logoUrl"
                        alt="Logo"
                        @error="onLogoError" >
                </div>

                <div class="mt-8">
                    <div class="mt-6">
                        <hts-form
                            class="space-y-6"
                            @submit="handleSubmitFormLogin">
                            <hts-form-radio
                                v-model="formData.registerBy"
                                label="Đăng nhập bằng"
                                :items="registerByItems"
                                value-key="key"
                                label-key="label" />

                            <hts-form-input
                                v-if="formData.registerBy === 'email'"
                                v-model="formData.email"
                                name="email"
                                prop="email"
                                :placeholder="$t('labels.emailAddress')"
                                @change="errorMessages = []">
                                <template #prefix>
                                    <hi-envelope-icon class="h-6 w-6 ml-2 text-gray-500" />
                                </template>
                            </hts-form-input>

                            <hts-form-phone
                                v-if="formData.registerBy === 'phone'"
                                v-model="formData.phone"
                                :placeholder="$t('labels.phone')"
                                prop="phone"
                                name="phone" />

                            <template v-for="error in errorMessages">
                                <p
                                    v-if="error"
                                    :key="error"
                                    class="text-xs text-error-500 ml-2">
                                    {{ error }}
                                </p>
                            </template>

                            <hts-form-input
                                v-model="formData.password"
                                name="password"
                                type="password"
                                prop="password"
                                :placeholder="$t('labels.password')"
                                @change="errorMessages = []">
                                <template #prefix>
                                    <hi-lock-closed-icon class="h-6 w-6 ml-2 text-gray-500" />
                                </template>
                            </hts-form-input>

                            <div class="flex items-center justify-between">
                                <hts-form-checkbox
                                    v-model="formData.remember"
                                    :items="checkboxList" />

                                <hts-link
                                    class="font-medium text-main-500"
                                    :to="routes.forgotPassword">
                                    {{ $t('labels.forgotPassword') }}?
                                </hts-link>
                            </div>
                            <div class="text-center">
                                <hts-form-button
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                                    class="w-full"
                                    :disabled="!activateLoginButton">
                                    <p class="flex items-center justify-center">
                                        {{ $t('labels.login') }}
                                        <hi-arrow-left-end-on-rectangle-icon class="h-6 w-6 ml-2" />
                                    </p>
                                </hts-form-button>

                                <div
                                    v-if="driverUrl"
                                    class="flex justify-center items-center mt-3">
                                    <span class="mr-1">
                                        Bạn là tài xế?
                                    </span>

                                    <hts-link
                                        :to="driverUrl"
                                        class="text-main-500">
                                        Tài xế
                                    </hts-link>
                                </div>
                                <div class="flex justify-center items-center mt-3">
                                    <span class="mr-1">
                                        {{ $t('labels.userRegister') }}
                                    </span>

                                    <hts-link
                                        :to="backUrl && query ? { name: 'auth-register', query } : { name: 'auth-register' }"
                                        class="text-main-500">
                                        {{ $t('labels.register') }}
                                    </hts-link>
                                </div>
                            </div>
                        </hts-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="hidden lg:block relative w-0 flex-1">
            <img
                class="absolute inset-0 h-full w-full object-cover"
                alt=""
                src="https://images.unsplash.com/photo-1505904267569-f02eaeb45a4c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1908&q=80" >
        </div>
    </div>
</template>
<script lang="ts" setup>
import data from '@/pages/trucker-[id]/company/user-group/-components/imports/data'

import { decode } from '@/utils/str'
const { registerByItems } = data()

definePageMeta({
  layout: 'auth'
})

const routes = {
  forgotPassword: {
    name: 'auth-forgot-password'
  },
  register: {
    name: 'auth-register'
  }
}
const activateLoginButton = ref(true)
const { auth } = $store()
const store = $store()
const route = useRoute()
const router = useRouter()

const backUrl = computed(() => String(route.query.backUrl) || null)
const tokenInvite = computed(() => String(route.query.token) || null)
const registerBy = computed(() => String(route.query.registerBy) || null)
const email = computed(() => String(route.query.email) || null)
const phone = computed(() => String(route.query.phone) || null)
const code = computed(() => String(route.query.code) || null)
const countryCode = computed(() => String(route.query.countryCode)?.replace('_', ' ') || null)
const query = computed(() => route.query || null)
const errorMessages = ref<string[]>([])
const loggedIn = ref(false)
const loading = ref(false)

const driverUrl = computed(() => {
  return useRuntimeConfig().public?.driverUrl
})

const formData = reactive({
  registerBy: 'email',
  email: '' as string | null,
  password: '',
  remember: false,
  phone: {
    countryCode: 'Vietnam +84',
    phone: '',
    code: '+84'
  } as { [key: string]: string } | null
})
const checkboxList = [
  {
    value: 'remember',
    label: $t('labels.rememberme')
  }
]

onMounted(() => {
  if (registerBy.value && registerBy.value !== 'undefined') {
    formData.registerBy = registerBy.value
  }

  if (email.value && email.value !== 'undefined') {
    formData.email = email.value
  }

  if (phone.value && phone.value !== 'undefined' && code.value && code.value !== 'undefined' && countryCode.value && countryCode.value !== 'undefined') {
    formData.phone = {}
    formData.phone.phone = phone.value
    formData.phone.code = code.value
    formData.phone.countryCode = countryCode.value
  }
})

const handleSubmitFormLogin = $lodash.debounce(async () => {
  try {
    const config = useRuntimeConfig().public
    const dataForm = {
      password: formData.password,
      client_id: config.clientId,
      client_secret: config.clientSecret,
      grant_type: 'password'
    } as { [key: string]: any }
    loading.value = true

    if (formData.registerBy === 'email') {
      dataForm.username = formData.email
    }

    if (formData.registerBy === 'phone') {
      const phoneCode = (formData.phone?.code || '').trim().replace(/([^0-9])/, '')
      const phoneNumber = (formData.phone?.phone || '').trim().replace(/([^0-9])/, '')
      dataForm.username = `${phoneCode}${phoneNumber}`
    }

    const res = await $api($url.auth.login, { body: new URLSearchParams(dataForm) }, false)

    const { data, success }: any = res?.data?.value || { data: null, success: false }
    const error = res?.error

    // const backUrl: string | null = String(route.query.backUrl) || null

    if (success) {
      const token = $lodash.get(data, 'access_token', '')
      const expiresIn = $lodash.get(data, 'expires_in', '')
      const refreshToken = $lodash.get(data, 'refresh_token', '')
      const companyTypes = $lodash.get(data, 'companyTypes', [])
      const isAdmin = $lodash.get(data, 'isAdmin')
      const workspaces = $lodash.get(data, 'workspaces', [])

      store.userConfig.workspaces = workspaces
      store.userConfig.isAdmin = isAdmin
      store.userConfig.companyTypes = companyTypes

      auth.setAccessToken(token)
      auth.setRefreshToken(refreshToken)
      auth.setExpires(expiresIn)

      if (backUrl.value && backUrl.value !== 'undefined') {
        if (Array.isArray(workspaces) && workspaces.length) {
          const workspace = workspaces[0]
          const { _sid, companyType, timezone, type, cooperatorTypes } = workspace
          const workspaceId = _sid
          auth.setWorkspace({ id: _sid, companyType, timezone, type, cooperatorTypes })
        }

        if (tokenInvite.value && !registerBy.value) {
          window.location.href = backUrl.value + `&token=${tokenInvite.value}`
          // navigateTo(backUrl.value + `&token=${tokenInvite.value}`)
        } else {
          // navigateTo(backUrl.value)
          window.location.href = backUrl.value
        }
        return
      }

      loggedIn.value = true
      if (Array.isArray(workspaces) && workspaces.length) {
        const workspace = workspaces[0]
        const { _sid, companyType, timezone, type, cooperatorTypes } = workspace

        const workspaceId = _sid

        auth.setWorkspace({ id: _sid, companyType, timezone, type, cooperatorTypes })

        if (type === 'VENDOR') {
          if (['OWNER'].includes(companyType)) {
            return router.push({
              name: 'trucker-id-dashboard',
              params: { id: workspaceId }
            })
          }
          if (['PARTNER'].includes(companyType)) {
            if (cooperatorTypes.includes('PARTNER')) {
              return router.push({
                name: 'pp-id',
                params: { id: workspaceId }
              })
            }

            if (cooperatorTypes.includes('CUSTOMER')) {
              return router.push({
                name: 'pc-id',
                params: { id: workspaceId }
              })
            }
          }
        }

        if (type === 'IMPORT_AND_EXPORT') {
          if (['OWNER'].includes(companyType)) {
            return router.push({
              name: 'c-id-dashboard',
              params: { id: workspaceId }
            })
          }
        }
      }

      return router.push({
        name: 'user-search-booking'
        // name: 'workspace-list'
      })
    }

    if (error && error.value) {
      const errorData = error.value.data || {}
      const errorDataList = errorData.errors || []

      if (Array.isArray(errorDataList) && errorDataList.length) {
        errorMessages.value = errorDataList.map((msgs: any) => {
          if (typeof msgs === 'string') {
            $toast().success(decode(msgs))
          }
          if (typeof msgs === 'object' && 'msg' in msgs) {
            return msgs.msg
          }
          if (Array.isArray(msgs) && msgs.length) {
            if (typeof msgs[0] === 'string') {
              return msgs[0]
            }
          }
          return ''
        })
      }
    } else {
      errorMessages.value = []
    }

    nextTick(() => {
      loading.value = false
    })
  } catch (e: any) {
    console.log(e)
  }
}, 500)

const logoUrl = computed(() => {
  const defaultLogoUrl = '/assets/logo.png'
  return defaultLogoUrl
})

const onLogoError = (event: Event) => {
  const target = event.target as HTMLImageElement
  target.style.display = 'none'
}

onBeforeUnmount(() => {
  if (loggedIn.value) {
    if (process.client) {
      $toast().success('Đăng nhập thành công')
    }
  }
})
</script>
